import React from 'react'
import {
  Card,
  useMediaSize,
  Table,
  SkeletonLoader,
  Space,
} from '@ally/metronome-ui'

import { useAccountTypes, useDebtPlanFocusAccount } from '../../providers'
import { getColumns } from './TableColumns'
import { useCustomizeDashboard } from '../../CustomizeDashboard/CustomizeDashboardContext'
import MobileDebtPlan from './MobileDebtPlan'
import DebtPlanError from './DebtPlanError'
import { useHostServices } from '../../HostServices'
import { customErrorAnalytics } from '../../analytics'
import {
  AccountCard,
  AccountCardMbox,
  AccountGroup,
  LobShell,
  NonPrintingWrapper,
} from '../Shared'

const DebtPlanContent = (): JSX.Element => {
  const { isDebtPlanOnlyUser } = useAccountTypes()
  const [{ dashboardView }] = useCustomizeDashboard()
  const { browserHistory } = useHostServices()

  const isLgDown = useMediaSize('LgDown')
  const isMdDown = useMediaSize('MdDown')
  const isPrint = window.matchMedia('print').matches

  const {
    data: focusDebtAccount,
    isLoading,
    isError,
  } = useDebtPlanFocusAccount()

  if (isLoading) {
    return (
      <Space mb="sm">
        <Card closeButton={false}>
          <SkeletonLoader.Container>
            <SkeletonLoader.Row height="s" width="xl" />
            <SkeletonLoader.Row height="l" width="xl" />
          </SkeletonLoader.Container>
        </Card>
      </Space>
    )
  }

  if (!focusDebtAccount || isError) {
    if (isDebtPlanOnlyUser) {
      // show full page error for debtPlan only users
      browserHistory.push('/dashboard-error', {
        // pass state for the <DashboardError>
        debtPlanOnlyUser: true,
      })

      return <></>
    }
    customErrorAnalytics('Debt Plan Outage')
    return <DebtPlanError />
  }

  return (
    <AccountGroup name="debt-plan">
      <AccountCard type="plan">
        {isMdDown && !isPrint ? (
          <MobileDebtPlan debtPlan={focusDebtAccount} />
        ) : (
          <Table
            config={{
              data: [focusDebtAccount],
              columns: getColumns({
                view: dashboardView,
                isLgDown,
              }),
            }}
            shared={{
              captionText: 'Information about your Ally Debt Plan',
              disableContainer: true,
            }}
            table={{
              fullWidth: true,
            }}
          />
        )}
        <NonPrintingWrapper>
          <AccountCardMbox name="ally-dashboard-debt-plan-well" />
        </NonPrintingWrapper>
      </AccountCard>
    </AccountGroup>
  )
}

export const DebtPlan = (): JSX.Element => {
  return (
    <LobShell header="Plan" customizeTriggerLob="plan">
      <DebtPlanContent />
    </LobShell>
  )
}
